<template>
    <div class="interior-view__head">
        <div class="interior-intro">
            <div class="interior-intro__title">
                <h1>{{ portfolio.subject }}</h1>
                <p>{{ portfolio.constructionSite }}</p>
            </div>
            <!-- 썸네일 -->

            <div class="interior-intro__thumb">
                <div class="interior-intro__thumb-main">
                    <span class="interior-intro__thumb-thumbnail">
                        <span v-if="portfolio.thumb" class="interior-intro__thumb-img" :style="{ backgroundImage: `url('${portfolio.thumb}')` }"></span>
                    </span>
                    <span class="interior-intro__thumb-image"></span>
                </div>
                <ul class="interior-intro__thumb-lists">
                    <!-- 콘텐트 이미지 -->
                    <!-- <li class="interior-intro__thumb-list"  v-for="item in portfolio.contents">
                        <div role="button" class="interior-intro__thumb-button" aria-pressed="false">
                            <span class="interior-intro__thumb-button-thumbnail">
                                <span class="interior-intro__thumb-button-img" :style="backImage(item.image)"></span>
                            </span>
                            <span class="interior-intro__thumb-button-image"></span>
                        </div>
                    </li> -->
                </ul>
            </div>
            <!-- 상세정보 -->
            <div class="interior-intro__info">
                <!-- 스펙 테이블 -->
                <div class="interior-intro__table">
                    <div class="interior-intro__table-row-group">
                        <div class="interior-intro__table-row">
                            <div class="interior-intro__table-th">시공범위</div>
                            <div class="interior-intro__table-td">
                                {{ portfolio.construction.scope }}
                            </div>
                        </div>
                        <div class="interior-intro__table-row">
                            <div class="interior-intro__table-th">주거유형</div>
                            <div class="interior-intro__table-td">
                                {{ portfolio.category.name }}
                            </div>
                        </div>
                        <div class="interior-intro__table-row">
                            <div class="interior-intro__table-th">공사면적</div>
                            <div class="interior-intro__table-td">{{ (+portfolio.construction.acreage || 0).format() }} 평대</div>
                        </div>
                        <div class="interior-intro__table-row">
                            <div class="interior-intro__table-th">공급가격</div>
                            <div class="interior-intro__table-td">
                                <div class="flexbox">
                                    <div>
                                        {{ (+portfolio.construction.supplyPrice || 0).format() }}
                                        만원
                                    </div>
                                    <button v-if="portfolio.estimate.type && portfolio.estimate.type != 'none'" class="button button--border-primary" type="button" @click="$refs.ModalPortfolioEstimate.modal = true">
                                        <span>시공 견적서 보기</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-if="portfolio.construction.discountPrice" class="interior-intro__table-row">
                            <div class="interior-intro__table-th">할인가격</div>
                            <div class="interior-intro__table-td">
                                <div class="flexbox">
                                    <div>
                                        {{ (+portfolio.construction.discountPrice || 0).format() }}
                                        만원 ({{ 100 - Math.floor((portfolio.construction.discountPrice / portfolio.construction.supplyPrice) * 100) }}%)
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="interior-intro__table-row">
                            <div class="interior-intro__table-th">컨셉</div>
                            <div class="interior-intro__table-td">
                                <span v-for="(concept, index) in portfolio.construction.concept" :key="index">{{ concept }} </span>
                            </div>
                        </div>
                        <div class="interior-intro__table-row">
                            <div class="interior-intro__table-th">컬러</div>
                            <div class="interior-intro__table-td">
                                {{ portfolio.construction.color }}
                            </div>
                        </div>
                        <!-- <div class="interior-intro__table-row">
                            <div class="interior-intro__table-th">요구사항</div>
                            <div class="interior-intro__table-td">{{portfolio.memo}}</div>
                        </div>
                        <div class="interior-intro__table-row">
                            <div class="interior-intro__table-th">업체명</div>
                            <div class="interior-intro__table-td">{{portfolio.user.company.name}}</div>
                        </div> -->
                    </div>
                </div>
                <!-- 주소 -->

                <div class="interior-intro__location">
                    <div class="interior-intro__location-thumb">
                        <span v-if="portfolio.user && portfolio.user.meta.logo" class="interior-intro__location-thumbnail" :style="{ backgroundImage: `url('${portfolio.user.meta.logo}')` }"></span>
                    </div>
                    <div class="interior-intro__location-text">
                        <span class="interior-intro__location-name">{{ portfolio.user.meta.companyName }}</span>
                        <span class="interior-intro__location-address">{{ portfolio.user.address1 }}</span>
                    </div>
                </div>
                <!-- 버튼 -->
                <div class="interior-intro__buttons">
                    <!-- 버튼 활성화 서브클래스: button--active -->
                    <button class="button button--border-thumbup" :class="{ 'button--active': isLike }" @click="!isLike ? like() : unlike()">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 330 331" style="enable-background: new 0 0 330 331" xml:space="preserve">
                            <path
                                d="M298,101c-12.9-7.1-28-9.2-42.4-6.1l-31,6.7l5.1-52c2.1-20.9-10.4-40.3-30.3-47.1c-11.6-4-24.1-3.1-35,2.5
                            c-11,5.6-19,15.1-22.6,26.8l-17.2,55.5c-4.2,13.7-14.8,24.8-28.2,29.7l-10.7,3.9H15c-8.3,0-15,6.7-15,15v160.4c0,4,1.6,7.8,4.4,10.6
                            c2.8,2.8,6.6,4.4,10.6,4.4l60.3,0l149.5,18.9c4.5,0.6,9.1,0.9,13.6,0.9c22.9,0,45.1-7.3,63.7-21.2l3.2-2.4
                            c15.5-11.5,24.7-29.9,24.7-49.2V154.8C330,132.4,317.7,111.7,298,101 M30,150.9h42.2l-9.9,130.4l-32.3,0L30,150.9L30,150.9z
                            M300,258.2c0,9.9-4.7,19.3-12.6,25.2l-3.2,2.4c-16,11.9-35.7,17.1-55.5,14.6L92.3,283.2l6.5-85.9l3.8-50.6l4.1-1.5
                            c22.1-8.1,39.5-26.4,46.5-48.9l17.2-55.5c1.2-3.9,3.9-7.1,7.6-9c3.7-1.9,7.8-2.2,11.7-0.8c6.7,2.3,10.8,8.8,10.1,15.8l-7.2,72.5
                            c-0.5,4.8,1.4,9.5,4.9,12.7c3.6,3.2,8.5,4.5,13.2,3.5l51.1-11.1c7.4-1.6,15.1-0.5,21.7,3.1c10.1,5.5,16.3,16.1,16.3,27.5V258.2z"
                            />
                        </svg>
                        <span class="blind">추천</span>
                        <span style="position:absolute;font-size:0.75em;color:gray;">{{ portfolio.likeCount }}</span>
                    </button>
                    <button class="button button--border-scrap" :class="{ 'button--active': isBookmark }" @click="!isBookmark ? bookmark() : unbookmark()">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <path fill-rule="evenodd" stroke-width="2.2px" stroke-linecap="butt" stroke-linejoin="round" fill="none" d="M22.100,14.100 L4.100,28.100 L4.100,4.100 L22.100,4.100 L22.100,28.100 L13.100,22.100 " />
                        </svg>
                        <span class="blind">스크랩</span>
                        <span style="position:absolute;font-size:0.75em;color:gray;">{{ portfolio.bookmarkCount }}</span>
                    </button>
                    <button class="button button--border-share" @click="$refs['modal-share'].modal = true">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 354 354" style="enable-background: new 0 0 354 354" xml:space="preserve">
                            <path
                                d="M289,129c25.9,0,49.2-15.6,59.1-39.5s4.4-51.4-13.9-69.7C315.9,1.4,288.4-4,264.5,5.9S225,39.1,225,65c0.1,6,1,12,2.8,17.8
                            L114,136.3c-17.2-20.8-45.6-28.7-71-19.5C17.5,125.9,0.6,150,0.6,177s17,51.1,42.4,60.2c25.4,9.1,53.8,1.3,71-19.5l113.9,53.5
                            C226,277,225.1,283,225,289c-0.1,30.6,21.4,57,51.4,63c30,6.1,60.1-9.9,71.9-38.1c11.8-28.2,2.1-60.8-23.2-78
                            c-25.3-17.1-59.2-14-81,7.5l-116.3-54.7c1.6-7.8,1.6-15.9,0-23.7l116.3-54.7C256,122.4,272.2,129,289,129 M289,33
                            c12.9,0,24.6,7.8,29.6,19.8c5,12,2.2,25.7-6.9,34.9c-9.2,9.2-22.9,11.9-34.9,6.9c-12-5-19.8-16.6-19.8-29.6
                            C257,47.3,271.3,33,289,33 M65,209c-12.9,0-24.6-7.8-29.6-19.8c-5-12-2.2-25.7,6.9-34.9c9.2-9.2,22.9-11.9,34.9-6.9
                            c12,5,19.8,16.6,19.8,29.6C97,194.7,82.7,209,65,209 M289,257c12.9,0,24.6,7.8,29.6,19.8c5,12,2.2,25.7-6.9,34.9
                            c-9.2,9.2-22.9,11.9-34.9,6.9c-12-5-19.8-16.6-19.8-29.6C257,271.3,271.3,257,289,257"
                            />
                        </svg>
                        <span class="blind">공유</span>
                    </button>
                    <button class="button button--primary" @click="inquireEstimate">
                        <span>현재 인테리어로 견적문의</span>
                    </button>
                </div>
            </div>
        </div>

        <modal-portfolio-estimate ref="ModalPortfolioEstimate" :portfolio="portfolio"></modal-portfolio-estimate>
        <modal-share ref="modal-share" v-bind="shareData" />
    </div>
</template>

<script>
import api from "@/api";
import ModalShare from "../common/modal-share/modal-share.vue";
import ModalPortfolioEstimate from "./estimate/modal-portfolio-estimate.vue";
export default {
    components: {
        ModalShare,
        ModalPortfolioEstimate,
    },
    props: {
        portfolio: { type: Object, default: null },
    },
    data: () => {
        return {
            me: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                var { user } = await api.v1.me.getProfile();
                this.me = user;
            } catch (error) {
                console.log(error);
            }
        },
        async like(mode) {
            try {
                if (!this.payload) throw new Error("로그인이 필요한 기능입니다.");

                var { like } = await api.v1.me.likes.postLike({
                    _portfolio: this.portfolio._id,
                });

                alert("좋아요 되었습니다");
                this.$set(this.me, "likes", [like, ...this.me.likes]);
                this.$set(this.portfolio, "likeCount", +this.portfolio.likeCount + 1);

                this.$emit("reload");
            } catch (error) {
                console.log(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async unlike() {
            try {
                await api.v1.me.likes.deleteLike({
                    _id: this.me.likes.find((like) => like._portfolio == this.portfolio._id)._id,
                });
                alert("좋아요가 취소되었습니다");
                this.$set(
                    this.me,
                    "likes",
                    this.me.likes.filter((like) => like._portfolio != this.portfolio._id)
                );
                this.$set(this.portfolio, "likeCount", +this.portfolio.likeCount - 1);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async bookmark() {
            try {
                if (!this.payload) throw new Error("로그인이 필요한 기능입니다.");

                var { bookmark } = await api.v1.me.bookmarks.postBookmark({
                    _portfolio: this.portfolio._id,
                });
                alert("북마크에 추가되었습니다");
                this.$set(this.me, "bookmarks", [bookmark, ...this.me.bookmarks]);
                this.$set(this.portfolio, "bookmarkCount", +this.portfolio.bookmarkCount + 1);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async unbookmark() {
            try {
                await api.v1.me.bookmarks.deleteBookmark({
                    _id: this.me.bookmarks.find((bookmark) => bookmark._portfolio == this.portfolio._id)._id,
                });
                alert("북마크가 취소되었습니다");
                this.$set(
                    this.me,
                    "bookmarks",
                    this.me.bookmarks.filter((bookmark) => bookmark._portfolio != this.portfolio._id)
                );
                this.$set(this.bookmark, "bookmarkCount", +this.portfolio.bookmarkCount - 1);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        inquireEstimate() {
            const {
                id: _portfolio,
                category: { id: _category },
            } = this.portfolio;
            this.$router.push(`/estimate/estimate-inquiry?_category=${_category}&_portfolio=${_portfolio}`);
        },
    },
    computed: {
        payload() {
            return this.$store.state.payload;
        },
        isLike() {
            return this.me?.likes?.find((like) => like._portfolio == this.portfolio._id) || false;
        },
        isBookmark() {
            return this.me?.bookmarks?.find((bookmark) => bookmark._portfolio == this.portfolio._id) || false;
        },
        description() {
            const { portfolio } = this;
            const { construction: desc } = portfolio || {};
            return [desc?.scope, portfolio?.category?.name, desc?.acreage ? desc?.acreage + "평" : undefined, ...(portfolio?.construction?.concept || []), desc?.color]
                ?.filter((item) => item)
                ?.map((item) => `#${item}`)
                .join(" ");
        },
        kakaoData() {
            const { portfolio, description } = this;
            const { subject: title, construction: desc, thumb, likeCount, bookmarkCount: subscriberCount, shareCount: sharedCount } = portfolio || {};

            const link = window.location.href;

            return {
                objectType: "feed",
                content: {
                    title,
                    description,
                    imageUrl: `https://ssezip.com${thumb}`,
                    link: {
                        mobileWebUrl: link,
                        webUrl: link,
                    },
                },
                social: {
                    likeCount,
                    subscriberCount,
                    sharedCount,
                },
                buttons: [
                    {
                        title: "웹으로 보기",
                        link: {
                            mobileWebUrl: link,
                            webUrl: link,
                        },
                    },
                ],
            };
        },
        shareData() {
            const { kakaoData } = this;
            return { kakaoData };
        },
        facebookData() {
            return {
                meta: [
                    { property: "og:url", content: "https://ssezip.com" + this.$route.path },
                    { property: "og:title", content: `새집처럼 - ${this.portfolio?.subject}` },
                    { property: "og:description", content: this.description },
                    { property: "og:image", content: `https://ssezip.com${this.portfolio?.thumb}` },
                ],
            };
        },
    },
    metaInfo() {
        return this.facebookData;
    },
};
</script>

<style lang="css" scoped></style>
